module.exports = __webpack_public_path__ + "static/media/icoadd.37e018b3.svg";